/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function SparklesIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="sparkles"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M9.882 7.401A6.832 6.832 0 0 1 3.164 14.118" data-tinysvg-shape="arc" data-tinysvg-arc="3.051 7.288 6.832 6.832 0.949 89.051 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M16.599 14.118A6.832 6.832 0 0 1 9.882 7.401" data-tinysvg-shape="arc" data-tinysvg-arc="16.712 7.288 6.832 6.832 90.949 179.051 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.164 14.118A6.832 6.832 0 0 1 9.882 20.836" data-tinysvg-shape="arc" data-tinysvg-arc="3.051 20.949 6.832 6.832 270.949 359.051 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M9.882 20.836A6.832 6.832 0 0 1 16.599 14.118" data-tinysvg-shape="arc" data-tinysvg-arc="16.712 20.949 6.832 6.832 180.949 269.051 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M17.084 3.239A4.477 4.477 0 0 1 13.407 6.916" data-tinysvg-shape="arc" data-tinysvg-arc="12.668 2.5 4.477 4.477 9.501 80.499 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(80)} data-tinysvg-stroke-width="80" />
          <path d="M20.761 6.916A4.477 4.477 0 0 1 17.084 3.239" data-tinysvg-shape="arc" data-tinysvg-arc="21.5 2.5 4.477 4.477 99.501 170.499 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(80)} data-tinysvg-stroke-width="80" />
          <path d="M13.407 6.916A4.477 4.477 0 0 1 17.084 10.593" data-tinysvg-shape="arc" data-tinysvg-arc="12.668 11.332 4.477 4.477 279.501 350.499 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(80)} data-tinysvg-stroke-width="80" />
          <path d="M17.084 10.593A4.477 4.477 0 0 1 20.761 6.916" data-tinysvg-shape="arc" data-tinysvg-arc="21.5 11.332 4.477 4.477 189.501 260.499 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(80)} data-tinysvg-stroke-width="80" />
    </svg>
  )
}
